import { Alert, Button, Col, Form, Input, Modal, Row, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useNavigate } from 'react-router-dom';

function Benefit() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Benefit Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: "level",
            render: (text, record) => (<p>{record.level_detail.name}</p>)
        },
        {
            title: 'Lodging',
            dataIndex: 'lodging_price',
            key: "lodging_price",
            render: (text, record) => (<p>{currencyFormat(record.lodging_price)}</p>)
        },
        {
            title: 'Join Visit',
            dataIndex: 'join_visit_price',
            key: "join_visit_price",
            render: (text, record) => (<p>{currencyFormat(record.join_visit_price)}</p>)
        },
        {
            title: 'Entertainment',
            dataIndex: 'entertainment_price',
            key: "entertainment_price",
            render: (text, record) => (<p>{currencyFormat(record.entertainment_price)}</p>)
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => record.created_at !== "" ? (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            render: (text, record) => record.updated_at !== "" ? (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button type="primary" style={{ marginRight: 10 }} onClick={() => navigate('/benefitform', { state: { item: record } })}>
                        <EditOutlined />
                        <b style={{ marginLeft: 5 }}>Edit</b>
                    </Button>
                    <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                        <DeleteOutlined />
                        <b style={{ marginLeft: 5 }}>Delete</b>
                    </Button>
                </>
            ),
        },
    ];

    useEffect(() => {
        getApi("GET", '/benefitlevel?search=' + search + '&page=' + page.pagination.current, 'division');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Are you sure you want to delete this data?',
            onOk: () => postApi('DELETE', '/benefitlevel/' + v.benefit_id, null),
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    }

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}            
            <h3>Benefit</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => { navigate('/benefitform') }}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
        </div>
    );
}

export default Benefit;
